import styled from 'styled-components';
export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;  
  width: 100%;
  height: 100%; 
  overflow: hidden;
  background: #ffffff;
`
